module.exports = __webpack_public_path__ + "img/saint_assassin_cover.07715df6.jpg";